import { MainSource } from './Source';

export enum RouteResource {
  Sources = 'sources',
  External = 'external',
  Search = 'search',
  Empty = 'empty',
  ShowAll = 'view',
  UnknownError = 'unknownError',
  Home = 'home',
  Boards = 'boards',
  AddFilesToBoardModal = 'addFilesToBoardModal',
  EnterpriseTab = 'enterprise',
}

export const RoutePath = {
  Source: `/${RouteResource.Sources}/:source?/:folderId?/:itemId?`,
  External: `/${RouteResource.External}/:externalSource`,
  Search: `/${RouteResource.Search}/:source?/:folderId?`,
  SearchAll: `/${RouteResource.Search}/all/:folderId?`,
  Empty: `/${RouteResource.Empty}`,
  ShowAll: `/${RouteResource.ShowAll}`,
  UnknownError: `/${RouteResource.UnknownError}`,
  Home: `/${RouteResource.Sources}/${RouteResource.Home}`,
  Boards: `/${RouteResource.Sources}/${RouteResource.Boards}`,
  ManageableMedia: `/${RouteResource.Sources}/${MainSource.SiteFiles}|${MainSource}`,
  EnterpriseTab: `/${RouteResource.EnterpriseTab}/:tab/:folderId?`,
};
